import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

proj4.defs(
	'EPSG:25832',
	'+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs'
);

register(proj4);

export const assetVersion = window.BSSP_VERSION || '2024-11-13-1000';

//export const extentBaseLeft = 1171400; // positiv == nach rechts
//export const extentBaseBottom = 6847950; // positiv == nach oben
//export const extentWidth = 280;
//export const extentHeight = 270;
export const extentBaseLeft = 1171000; // positiv == nach rechts
export const extentBaseBottom = 6847750; // positiv == nach oben
export const extentWidth = 1200;
export const extentHeight = 700;

export const contentExtentWidth = 196;
export const contentExtentHeight = 282.8;

export const debugImageExtentBaseLeft = 603939; // positiv == nach rechts
export const debugImageExtentBaseBottom = 5791459.5; // positiv == nach oben
export const debugImageExtentWidth = 188.5;
export const debugImageExtentHeight = 172;

export const splitViewBreakpoint = 850; // px

const initialViewportWidth = Math.max(
	document.documentElement.clientWidth || 0,
	window.innerWidth || 0
);

export const isSplitView = initialViewportWidth < splitViewBreakpoint;

export const extent = [
	extentBaseLeft,
	extentBaseBottom,
	extentBaseLeft + extentWidth,
	extentBaseBottom + extentHeight,
];

export const debugImageExtent = [
	debugImageExtentBaseLeft,
	debugImageExtentBaseBottom,
	debugImageExtentBaseLeft + debugImageExtentWidth,
	debugImageExtentBaseBottom + debugImageExtentHeight,
];

export const center = [1171542.5, 6848085];
export const minZoom = 17;
export const maxZoom = 21;

// See `docs/HOW_TO_UPDATE_DATA.md` for more info
export const enableDataEditing = false;

// Dumps a list of ${z}/${x}/${y} in console
export const enableTilesConsoleDump = false;

export const tileLayerPreloadNumber = 9;
export const tileLayerSourceOptions = {
	url:
		'/apps/standplan/tiles/{z}_{x}_{y}.png?v=' +
		assetVersion,
	//url: 'https://api.mapbox.com/styles/v1/neonaut/ckf82fnw953nq19qnmjc34qov/tiles/256/{z}/{x}/{y}@2x?v=2022-001&access_token=pk.eyJ1IjoibmVvbmF1dCIsImEiOiJjaWY2bXgwNTAwMDdodGltNHZpdGZ5N25yIn0.vRh5xBPnjmsARhQTuLvSUQ',
	//url: 'https://api.mapbox.com/styles/v1/neonaut/cla89s75i001k14sa19gr353j/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibmVvbmF1dCIsImEiOiJjaWY2bXgwNTAwMDdodGltNHZpdGZ5N25yIn0.vRh5xBPnjmsARhQTuLvSUQ',
	//url: 'https://www.braunschweig.de/tiles/street/{z}/{x}/{y}.png',
	//url: 'https://www.braunschweig.de/tiles/aerial/{z}/{x}/{y}.png',
	//url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
};

export const debugOverlayLayerSourceOptions = false; /* {
	imageExtent: debugImageExtent,
	projection: 'EPSG:25832',
	url: '/img/standplan/karte.png',
	interpolate: true,
}; */

export const imageOverlayLayerSourceOptions = null; /* {
	imageExtent: extent,
	url: '/img/standplan/overlay.png',
}; */

//export const dataUrl = `/apps/pulp/result/standplan.geojson?v=${assetVersion}`;
//export const dataUrl = `/apps/standplan/assets/geometries.geojson?v=${assetVersion}`;
export const dataUrl = `/apps/pulp/result/standplan.geojson?v=${assetVersion}`;
